import { State } from 'interfaces/state'
import {
  Accomplishment,
  BaseRewardsPayload,
  GetRedemptionsApiPayload,
  GetRedemptionsQueryPayload,
  GetRewardsApiPayload,
  RedemptionStepNumber,
} from 'interfaces/bounty'
import { OrderingApiPayload, PaginatableApiPayload } from 'interfaces/ajax/payload'
import { PaginatableMeta, PaginatablePayload, SortableMeta, SortablePayload } from 'interfaces/table'
import { isSuccessAction } from 'helpers/actionsHelpers'
import { GET_REDEMPTION_ACCOUNT, GET_REWARDS_SUMMARY, SetRewardSummaryAction } from 'actions/bountyActions'
import { Action } from 'actions'
import { REDEMPTION_ENTRY_URL } from 'tangle-shared'
import { REDEMPTION_STEP_NAME_BY_STEP_NUMBER } from 'constants/bounty'

export function extractPaginatableApiPayload<T extends PaginatableMeta, A extends PaginatablePayload> (state: T, payload: A): PaginatableApiPayload {
  const {
    page,
    pageSize,
  } = payload

  const {
    pageSize: statePageSize,
    page: statePage,
  } = state


  const result: PaginatableApiPayload = {
    page: page || statePage,
    page_size: pageSize || statePageSize,
  }

  return result
}

export function extractOrderingApiPayload<T extends SortableMeta, A extends SortablePayload> (state: T, payload: A): OrderingApiPayload {

  const sorting = payload.sorting || state.sorting

  if (!sorting) {
    return { ordering: '' }
  }

  const { columnName, direction } = sorting

  return {
    ordering: `${ direction === 'desc' ? '-' : '' }${ columnName }`,
  }
}

export function constructGetRewardsApiPayload (state: State, payload: BaseRewardsPayload): GetRewardsApiPayload {
  const { items } = state.app.bounty.reward
  const { filter } = payload
  const { filter: stateFilter } = items

  const result: GetRewardsApiPayload = {
    ...extractPaginatableApiPayload(items, payload),
    is_dismissed: false,
  }

  const activeFilter = filter || stateFilter
  if (activeFilter === 'dismissed') {
    result.is_dismissed = true
  } else if (activeFilter !== 'all' && activeFilter !== 'crypto') {
    result.status = activeFilter
  }
  if (activeFilter === 'crypto') {
    result.transaction_type = 'crypto'
  }

  return result
}

export const extractRedemptionPayload = (action: Action) =>
  action.type === GET_REDEMPTION_ACCOUNT && isSuccessAction(action)
    ? action.payload.response
    : null

export const extractRewardSummaryPayload = (action: Action) =>
  action.type === GET_REWARDS_SUMMARY && isSuccessAction(action)
    ? action.payload.response
    : action.type === SetRewardSummaryAction.type
      ? action.payload
      : null

export function constructGetRedemptionsApiPayload (state: State, payload: GetRedemptionsQueryPayload): GetRedemptionsApiPayload {
  const { items } = state.app.bounty.redemption

  return {
    ...extractPaginatableApiPayload(items, payload),
    ...extractOrderingApiPayload(items, payload),
  }
}

export const getRedemptionFormUrl = (stepNumber: RedemptionStepNumber) =>
  `${ REDEMPTION_ENTRY_URL }/${ REDEMPTION_STEP_NAME_BY_STEP_NUMBER[stepNumber] }`

export function isAccomplishedRewardTracking (accomplishment: Accomplishment): boolean {
  return accomplishment.slug === 'reward_is_tracking'
}

export function hasTrackingAccomplishedRewards (accomplishments: Accomplishment[]): boolean {
  return Boolean(accomplishments.find(isAccomplishedRewardTracking))
}
